import { AppConstants, Types } from '../../../common/APIConstants';
import { action, observable, toJS } from 'mobx';
import SmartSelect from '../../../common/SmartSelect';
import CustomDateComponent from '../../../common/CustomDateComponent';
import ReactDatePicker from 'react-datepicker';

import ReferenceDataService from '../services/reference-data-service';
import { Datepicker } from '../../../common/Datepicker';
import { DateFormatter, DateTimeFormatter } from '../../../common/DateFormatter';
import { NumberFormatter, DecimalFormatter, DecimalAllDigitsFormatter } from '../../../common/NumberFormatter';
import NumericCellEditor from '../../../common/NumericCellEditor';
import ActionsRenderer from '../../../common/ActionsRenderer';
import { types } from '@babel/core';
import moment from 'moment';
import { isNumber } from 'lodash';
import RestEndPoint from '../../../common/RestEndPoint';

class ReferenceDataStore {
  @observable saveBtnText = 'Save';
  @observable addRowBtnText = 'Add';
  @observable deleteBtnText = 'Delete';
  @observable exportBtnText = 'Export';
  @observable refreshBtnText = 'Refresh';
  @observable copyBtnText = 'Copy';

  @observable rowData = [];
  @observable rowDataFetched = false;
  @observable columnDefinitions = [];
  @observable selectedData = [];

  @observable defaultLookupItem = { id: 'All', value: 'All' };

  getGridData = async (currentScreen) => {
    try {
      const { data } = await ReferenceDataService.getGridData(currentScreen);
      const { screen, screenColumns: columns } = currentScreen;

      this.columnDefinitions = [];
      this.rowData = [];
      this.selectedData = [];

      this.columnDefinitions = this.getColumnDefinitions(screen, columns);
      this.rowData = data;
      this.rowDataFetched = true;
    } catch (error) {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        headerTooltip: column.title,
        tooltip: (params) => this.getToolTip(params, column),
        type: 'text',
        width: column.width ? column.width : 200,
        pinned: column.pinned ? 'left' : null,
        cellClass: params => {
          return column.required && params.node.data && !params.node.data[column.name] ? 'requiredCell' : '';
        },
        filter: this.getColumnFilter(column),
        filterParams: this.getColumnFilterParams(column),
        hide: column.hidden,
        editable: (params) => (params.node.data.isNewRow && !column.nonDataEntryField) ? true : (screen.canEditRow && !column.readOnly),
        cellRenderer: this.getFormatter(column),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column) },

        valueParser: (params) => { return this.getValueParser(params, column) },
        ChildDependencyField: column.childDependencyField,
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value }
      });
    });
    return gridColumns;
  };

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else {
      return mappings.values.find(item => item.value == key).label;
    }

  }
  lookupValueReference(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else
      return mappings.values.find(item => item.value == key).dependencykey;

  }
  lookupKey(mappings, name) {
    let valueItem;
    for (valueItem in mappings) {
      if (mappings.hasOwnProperty(valueItem)) {
        if (name === mappings[valueItem].label) {
          return mappings[valueItem].value;
        }
      }
    }
  }
  getToolTip(params, column) {
    const toolTip = (column.type !== Types.DROPDOWN && params.node.data) ? params.node.data[column.name] : null;
    return toolTip;
  }
  getValueFomatter(params, column) {
    if (column.type === Types.DROPDOWN && column.refLookupData != null) {
      return this.lookupValue(column.refLookupData.lookupValues, params.value);
    }
    else {
      switch (column.type) {
        case Types.DATE:
          return 'dateTimeFormatter';
        case Types.DATETIME:
          return 'dateTimeFormatter';
        case Types.NUMBER:
          return NumberFormatter;
        case Types.DECIMAL:
          return DecimalFormatter;
        case Types.DECIMALALLDIGITS:
          return DecimalAllDigitsFormatter;
      }
    }
  }
  getValueParser(params, column) {
    if (column.type === Types.DROPDOWN && column.refLookupData != null) {
      return this.lookupKey(column.refLookupData.lookupValues, params.newValue);
    }
    else
      return params.newValue;
  }
  getValueGetter(params, column) {
    if (column.type === Types.DROPDOWN && column.refLookupData !== null && params.data) {
      var isNumeric = isNumber(parseInt(params.data[column.name]));
      if (isNumeric) {
        return this.lookupValue(column.refLookupData.lookupValues, params.data[column.name]);
      }
    }
    else if (!params.data) {
      return null;
    }
    else
      return params.data[column.name];
  }

  getCellEditorFramework(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return SmartSelect;
      case Types.DATE:
        return 'datePicker';
      case Types.DATETIME:
        return 'datePicker';
      case Types.NUMBER:
        return 'numericCellEditor';
      case Types.DECIMAL:
        return 'decimalCellEditor';
      case Types.TEXT:
        return 'agTextCellEditor';
      case Types.DECIMALALLDIGITS:
        return 'decimalCellEditor';
    }
  }
  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelect';
      case Types.DATE:
        return 'datePicker';
      case Types.DATETIME:
        return 'datePicker';
      case Types.NUMBER:
        return 'numericCellEditor';
      case Types.DECIMAL:
        return 'decimalCellEditor';
      case Types.BOOLEAN:
        return 'booleanCellEditor';
      case Types.TEXT:
        return 'agTextCellEditor';
      case Types.DECIMALALLDIGITS:
        return 'decimalCellEditor';
    }
  }

  getCellEditorParams(column, params) {
    switch (column.type) {
      case Types.DROPDOWN:
        if (column.dependencyColumn) {
          const dependecyValue = params.node.data[column.dependencyColumn];
          if (dependecyValue) {
            const dependencyList = column.refLookupData?.lookupValues.values.filter(x => x.dependencykey === dependecyValue);
            let depenList = { values: [] }
            Object.assign(depenList.values, (dependencyList))
            return depenList;
          }
          else
            return column.refLookupData?.lookupValues;
        }
        else
          return column.refLookupData?.lookupValues;
    }
  }

  getFormatter(column) {
    switch (column.type) {
      case Types.DATE:
        return 'dateFormatter';
      case Types.DATETIME:
        return 'dateTimeFormatter';
      case Types.NUMBER:
        return 'numberFormatter';
      case Types.DECIMAL:
        return 'decimalFormatter';
      case Types.BOOLEAN:
        return 'booleanCellEditor';
      case Types.DECIMALALLDIGITS:
        return 'DecimalAllDigitsFormatter';
    }
  }

  getColumnFilter(column) {
    switch (column.type) {
      case Types.DATE:
        return 'agDateColumnFilter';
      case Types.DATETIME:
        return 'agDateColumnFilter';
      case Types.NUMBER:
        return 'agNumberColumnFilter';
      case Types.DECIMAL:
        return 'agNumberColumnFilter';
      case Types.TEXT:
        return 'agTextColumnFilter';
      default:
        return 'agSetColumnFilter';
    }
  }

  getColumnFilterParams(column) {
    const dateFilterParams = {
      // provide comparator function
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = cellValue;

        if (dateAsString == null) {
          return 0;
        }

        // In the example application, dates are stored as mm/dd/yyyy
        // We create a Date object for comparison against the filter date
        //const dateParts = dateAsString.split('/');
        const dateObjParts = moment(dateAsString).format('l');
        const cellDate = dateObjParts;
        const fltrdate = moment(filterLocalDateAtMidnight).format('l');;
        if (cellDate < fltrdate) {
          return -1;
        } else if (cellDate > fltrdate) {
          return 1;
        }
        return 0;
      }
    };

    switch (column.type) {
      case Types.DATE:
        return dateFilterParams;
      case Types.DATETIME:
        return dateFilterParams;
      default:
        return null;
    }
  }
  saveRowData = async (currentScreen, data) => {
    try {
      const toAdd = data.isNewRow === true;

      if (toAdd) {
        const addScreen = {};
        delete data.isNewRow;

        Object.assign(addScreen, currentScreen);
        addScreen.data = data;
        await ReferenceDataService.saveData(addScreen).then(function () { window.toastr.success(AppConstants.TOASTER_SUCCESS); });
      }

      if (!toAdd) {
        const updateScreen = {};
        delete data.isNewRow;

        Object.assign(updateScreen, currentScreen);
        updateScreen.data = data;
        await ReferenceDataService.updateData(updateScreen).then(function () { window.toastr.success(AppConstants.TOASTER_SUCCESS); });
      }
      this.selectedData = [];
    } catch (error) {
      console.log(error);
      if (error.response.data) {

        window.toastr.error(error.response.data);

      }
      else
        window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };
  saveData = async (currentScreen) => {
    try {
      const toAdd = this.selectedData.filter((x) => x.isNewRow);
      const toUpdate = this.selectedData.filter((x) => !x.isNewRow);

      if (toAdd.length) {
        const addScreen = {};
        const addData = toAdd.map((item) => {
          delete item.isNewRow;
          return item;
        });

        Object.assign(addScreen, currentScreen);
        addScreen.data = addData;
        await ReferenceDataService.saveData(addScreen);
      }

      if (toUpdate.length) {
        const updateScreen = {};
        const updateData = toUpdate.map((item) => {
          delete item.isNewRow;
          return item;
        });

        Object.assign(updateScreen, currentScreen);
        updateScreen.data = updateData;
        await ReferenceDataService.updateData(updateScreen);
      }

      this.selectedData = [];
    } catch (error) {
      console.log(error);
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };

  deleteData = async (currentScreen, selectedRow) => {
    try {
      const deleteScreen = {};
      const currentUser = RestEndPoint.getCurrentUserName();
      Object.assign(deleteScreen, currentScreen);

      if (deleteScreen['screen']['navWrapper'] === 'DigMasterListsScreen') {
        //Only for digmaster tracker
        selectedRow[0]['DeletedBy'] = currentUser;
        selectedRow[0]['DeletedDate'] = new Date();
      }
      deleteScreen.data = selectedRow;

      await ReferenceDataService.deleteData(deleteScreen).then(
        function () { window.toastr.success(AppConstants.TOASTER_Delete); });
    } catch (error) {
      console.log(error);
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };

  copyData = async (currentScreen, selectedRow) => {
    try {
      const copyScreen = {};
      Object.assign(copyScreen, currentScreen);
      copyScreen.data = selectedRow;
      await ReferenceDataService.saveData(copyScreen);
    } catch (error) {
      console.log(error);
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };

}

export default new ReferenceDataStore();
